module.exports = __webpack_public_path__ + "img/512.835854e0.svg";